import { render, staticRenderFns } from "./TableRender.vue?vue&type=template&id=f1bee5de&"
import script from "./TableRender.vue?vue&type=script&lang=js&"
export * from "./TableRender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports